module.exports = __webpack_public_path__ + "img/portrait-007.3e59b8d6.jpg";